import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {ApiService} from './api.service';
import {JwtService} from './jwt.service';
import {UserService} from './user.service';

@Injectable()
export class AuthService {
  user: User;

  constructor(
    private readonly router: Router,
    private readonly apiService: ApiService,
    private readonly jwtService: JwtService,
    private readonly userService: UserService
  ) {
  }

  login(email: string, password: string) {
    this.apiService
      .post(`/login`, {
        email,
        password
      })
      .subscribe(
        data => {
          console.log(data);
          const user: any = {};
          user.token = data.access_token;
          this.jwtService.saveToken(data.access_token);
          this.apiService.get('/user').subscribe(
            u => {
              this.userService.setAuth(u);
              this.router.navigate(['dashboard', 'customers']);
            },
            err => this.userService.purgeAuth()
          );
        },
        err => {
          alert('E-mail ou mot de passe incorrect');
        }
      );
  }

  logout() {
    this.apiService.post(`/logout`).subscribe(() => {
      this.userService.purgeAuth();
      this.router.navigate(['auth', 'login']);
    });
  }
}
